const isHomepage = () => {
    return window.location.pathname === "/" || window.location.pathname === null || window.location.pathname === "/home";
}

export default isHomepage;